import angular from 'angular';
import { NsjRadioButtonController } from './nsj-radio-button.controller';

export class NsjRadioButtonComponent implements angular.IComponentOptions {
    static selector = 'nsjRadioButtonComponent';
    static controller = NsjRadioButtonController;
    static template = require('!!html-loader!./nsj-radio-button.html');
    static transclude = false;
    static bindings = {
      label: '@',
      name: '@',
      ngModel: '=',
      options: '<',
      disabled: '<?',
      required: '<?',
      layout: '@',
      ngChange: '&?'
    };
}
